import axios from "axios";


export const sdtV2Service = {
    baseUrl:'',
    headers:'',
    options:'',
    userName:'',

    setBaseUrlAndUsername(serviceURL, username, token) {

		this.baseUrl = serviceURL;
		this.userName = username;
        this.headers = {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            }
        }
    },

	errorHandler(error) {

		return Observable.throw(error || "SERVER ERROR");
	},

	getViews(page) {

        return axios
            .get(this.baseUrl + "/views?user="+this.userName+"&pageId="+page, this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
            });
    },

    async getViewByName(page, viewName){
		return await axios
            .get(this.baseUrl + "/views?viewName="+viewName+"&user="+this.userName+"&pageId="+page, this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
        });

    },

    async setViews(view) {

    	view.defaultTable.user = this.userName;
        // window.console.log(view);

		return await axios
            .post(this.baseUrl + "/views",view, this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
        });
	},

	async setDefaultView(page, viewName) {
		return await axios
            .put(this.baseUrl + "/views?viewName="+viewName+"&user="+this.userName+"&pageId="+page,'', this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
        });

	},

	async removeView(page, viewName) {

		return await axios
            .delete(this.baseUrl + "/views?viewName="+viewName+"&user="+this.userName+"&pageId="+page, this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
        });
    },

    async editViewName(oldViewName, newViewName,page) {
		return await axios
            .put(this.baseUrl + "/edit?oldViewName="+oldViewName+"&newViewName="+newViewName+"&pageId="+page,'', this.headers)
            .then(response => {
                const data = response;
                return data;
                })
            .catch(error => {
                throw error;
        });
    },

    async saveViewTileOrder(page,viewsUpdated) {
		return await axios
        .put(this.baseUrl + "/viewsorder?user="+this.userName+"&pageId="+page,viewsUpdated, this.headers)
        .then(response => {
                const data = response;
                return data;
            })
            .catch(error => {
                throw error;
        })
    }

}